import { Box, CardComponent, Span, Spinner } from '@bpba/ui-components';
import DataTable, { TableColumn } from 'react-data-table-component';
import { customStyles, EmptyState, FadeSwap } from './styled';
import { InformesAnterioresModel } from '../../rest/models/informesAnterioresModel';

type Props = {
  loading: boolean;
  data: InformesAnterioresModel[];
  columns: TableColumn<InformesAnterioresModel>[];
  errorMessage: string | null;
  onRowClick?: (row: InformesAnterioresModel) => void;
};

export const TableCard = ({ loading, data, columns, errorMessage, onRowClick }: Props) => (
  <CardComponent
    id="informes-tabla"
    width={['100%', '100%', '100%', '100%', '72%']}
    display="block"
    p={0}
    borderRadius={['md', null, 'md', 'md', 'lg']}
    style={{ overflow: 'hidden', height: '370px' }}
    role="region"
    aria-label="Listado de informes"
    aria-busy={loading || undefined}
    aria-live="polite"
  >
    {loading ? (
      <FadeSwap key="loading">
        <Box width="100%" minHeight="370px" justifyContent="center" alignItems="center" p={5}>
          <Spinner size="40px" color="primary.0" aria-label="Cargando informes" />
        </Box>
      </FadeSwap>
    ) : (
      <FadeSwap key="data">
        <DataTable
          columns={columns}
          data={data}
          customStyles={customStyles}
          onRowClicked={onRowClick}
          pointerOnHover={!!onRowClick}
          highlightOnHover={!!onRowClick}
          noDataComponent={
            <EmptyState>
              <Span
                role={errorMessage ? 'alert' : undefined}
                fontWeight={600}
                fontSize={[2, 3]}
                lineHeight={[2, 3]}
                color="secondary.1"
                style={{ opacity: 0.6, textAlign: 'center' }}
              >
                {errorMessage ?? 'No encontramos informes'}
              </Span>
            </EmptyState>
          }
          responsive
        />
      </FadeSwap>
    )}
  </CardComponent>
);
